export const collectorPermission = (
  permission,
  role,
  bpSettings,
  managerPermission,
) => {
  const permissions = [
    {
      value: "customerAdd",
      label: "customerAdd",
      isChecked: permission?.customerAdd,
      disabled: false,
    },
    {
      value: "customerEdit",
      label: "customerEdit",
      isChecked: permission?.customerEdit,
      disabled: false,
    },
    {
      value: "customerActivate",
      label: "customerActivate",
      isChecked: permission?.customerActivate || false,
      disabled: false,
    },
    {
      value: "customerDeactivate",
      label: "customerDeactivate",
      isChecked: permission?.customerDeactivate || false,
      disabled: false,
    },
    {
      value: "updateCustomerBalance",
      label: "updateCustomerBalance",
      isChecked: permission?.updateCustomerBalance || false,
      disabled: false,
    },
    {
      value: "viewCustomerList",
      label: "customerList",
      isChecked: permission?.viewCustomerList,
      disabled: false,
    },
    {
      value: "connectionFee",
      label: "connectionFee",
      isChecked: permission?.connectionFee, //ToDo
      disabled: false,
    },
    {
      value: "billingCycleUpdate",
      label: "billingCycleUpdate",
      isChecked: permission?.billingCycleUpdate || false,
      disabled: false,
    },
    {
      value: "customerMobileEdit",
      label: "mobileNumberUpdate",
      isChecked: permission?.customerMobileEdit, //ToDo
      disabled: false,
    },
    {
      value: "sendSMS",
      label: "sendSMS",
      isChecked: permission?.sendSMS,
      disabled: false,
    },
    {
      value: "billPosting",
      label: "billPosting",
      isChecked: permission?.billPosting,
      disabled: false,
    },
    {
      value: "billPrint",
      label: "printInvoiceBill",
      isChecked: permission?.billPrint,
      disabled: false,
    },
    {
      value: "billDelete",
      label: "billReportDelete",
      isChecked: permission?.billDelete,
      disabled: !(role === "ispOwner"
        ? bpSettings?.reportDelete
        : role === "manager" &&
          managerPermission?.reportDelete &&
          bpSettings?.reportDelete),
    },
    {
      value: "bulkStatusEdit",
      label: "bulkStatusEdit",
      isChecked: permission?.bulkStatusEdit,
      disabled: !(role === "ispOwner"
        ? bpSettings?.bulkStatusEdit
        : role === "manager" &&
          bpSettings?.bulkStatusEdit &&
          managerPermission?.bulkStatusEdit),
    },
    {
      value: "dashboardCollectionData",
      label: "dashboardCollectionData",
      isChecked: permission?.dashboardCollectionData,
      disabled: !role === "ispOwner" ? true : false,
    },
    {
      value: "expenditure",
      label: "expenditure",
      isChecked: permission?.expenditure,
      disabled: !role === "ispOwner" ? true : false,
    },
    {
      value: "instantRechargeBillPrint",
      label: "instantRechargeBillPrint",
      isChecked: permission?.instantRechargeBillPrint,
      disabled: !(role === "ispOwner"
        ? bpSettings?.instantRechargeBillPrint
        : role === "manager" &&
          bpSettings?.instantRechargeBillPrint &&
          managerPermission?.instantRechargeBillPrint),
    },
    {
      value: "bulkPaymentStatusEdit",
      label: "bulkPaymentStatusEdit",
      isChecked: permission?.bulkPaymentStatusEdit,
      disabled: !(role === "ispOwner"
        ? bpSettings?.bulkPaymentStatusEdit
        : role === "manager" &&
          bpSettings?.bulkPaymentStatusEdit &&
          managerPermission?.bulkPaymentStatusEdit),
    },
    {
      value: "package",
      label: "customerPackageUpdate",
      isChecked: permission?.package,
      disabled: role === "ispOwner" ? false : !managerPermission?.package,
    },
    {
      label: "oltUserMonitor",
      value: "oltUserMonitor",
      isChecked: permission?.oltUserMonitor,
      disabled: !bpSettings?.oltUserMonitor,
    },
    {
      label: "webhookMessageLog",
      value: "webhookMessageLog",
      isChecked: permission?.webhookMessageLog,
      disabled: false,
    },
    {
      label: "ipnMessageLog",
      value: "ipnMessageLog",
      isChecked: permission?.ipnMessageLog,
      disabled: false,
    },
    {
      label: "dailyRechargeFeature",
      value: "dailyRechargeFeature",
      isChecked: permission?.dailyRechargeFeature,
      disabled: false,
    },
    {
      label: "monthlyBillAdjustmentOnRecharge",
      value: "monthlyBillAdjustmentOnRecharge",
      isChecked: permission?.monthlyBillAdjustmentOnRecharge,
      disabled: false,
    },
  ];

  return permissions;
};
